import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthContext } from '../context/AuthContext';
import { Container, Row, Col, Spinner } from 'react-bootstrap';

const ProtectedRoute = ({ children, adminOnly = false, userOnly = false, providerOnly = false }) => {
  // Get auth state from context
  const { isAuthenticated, isAdmin, isUser, user, loading } = useAuthContext();
  const isProvider = user?.role === 3;
  
  // Show loading while checking
  if (loading) {
    return (
      <Container fluid className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <Row className="w-100">
          <Col className="text-center">
            <Spinner animation="border" role="status" className="mb-3" />
            <p>Inakupakia...</p>
          </Col>
        </Row>
      </Container>
    );
  }
  
  // Not logged in? Go to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  // Need admin but not admin? Go to user dashboard
  if (adminOnly && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }
  
  // Need user (non-admin) but is admin? Can still view, admin has more privileges
  if (userOnly && !isUser && !isAdmin) {
    return <Navigate to="/login" replace />;
  }
  
  // Need provider but is not provider? Go to dashboard
  if (providerOnly && !isProvider) {
    return <Navigate to="/dashboard" replace />;
  }
  
  // All good, show the page
  return children;
};

export default ProtectedRoute;